import styled from "styled-components";
import { Tooltip } from "antd";

export const TooltipContainer = styled(Tooltip)`
  position: relative;
  left: 10px;
  display: inline-block;
`;

export const MarketMovementTooltip = styled(Tooltip)`
    position: relative;
    left: 10px;
    display: inline-block;
    .ant-tooltip-inner{
      white-space: nowrap !important;
    }
`;

export const TooltipCircle = styled.img`
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-right: 26px;
`;
